import {z} from 'zod';
import {CampaignStep} from '../../campaignWorkflow/campaignWorkflow.enums';
import {Routes} from '../../routing/routing.config';
import routingService from '../../routing/routing.service';
import {campaignWorkflowPreDispatchParamsSchema} from '../copilot/copilotCampaigns.schemas';
import {AppRouteParams} from '../../routing/routing.types';

function _getOpenedCampaignSteps(): CampaignStep[] {
  const urlParams = new URLSearchParams(window.location.search);
  const stepsParam = urlParams.get('steps');
  const steps = stepsParam?.split(',');

  return (steps ?? []) as CampaignStep[];
}

function createNavigateToCampaignWorkflowStep(step: CampaignStep) {
  async function navigateToCampaignWorkflowStep({
    campaignId,
    versionNumber = 'latest',
    queryParams = {},
  }: z.infer<ReturnType<typeof campaignWorkflowPreDispatchParamsSchema>> & {
    queryParams?: AppRouteParams;
  }) {
    const visibleSteps = _getOpenedCampaignSteps();

    if (visibleSteps.includes(step)) {
      return;
    }

    // override the steps to be just the requested step
    routingService.goTo({
      url: Routes.CampaignPage,
      pathParams: {
        campaignId,
        versionNumber,
      },
      queryParams: {
        steps: step,
        ...queryParams,
      },
    });
  }

  return navigateToCampaignWorkflowStep;
}

export default createNavigateToCampaignWorkflowStep;
